import { getExpandingWildAction } from 'automaton/actions/ExpandingWildAction'
import { getWinBigAction } from 'automaton/actions/WinBigAction'
import { getWinMultiplyAction } from 'automaton/actions/WinMultiplyAction'
import { getWinScatterAction } from 'automaton/actions/WinScatterAction'
import { getWinSmallAction } from 'automaton/actions/WinSmallAction'
import { getRespinState } from 'automaton/states/RespinState'
import { getTransitionState } from 'automaton/states/TransitionState'
import { spinSettings } from 'settings/custom/reels'

import { AutoSpinManager } from '../../managers/AutoSpinManager'
import { getAutoState } from './AutoSpinState'
import { getFreespinAddState } from './FreespinsAddState'

export function getWinState() {
  const winModel = game.models.WinModel.get()
  const spinModel = game.models.SpinModel.get()
  const freespinModel = game.models.FreespinModel.get()
  const name = 'WIN'
  const actions = [
    getExpandingWildAction(),
    winModel.winType === 'regular'
      ? getWinSmallAction(true)
      : getWinBigAction(),
    getWinMultiplyAction(),
    getWinScatterAction(),
  ]
  if(spinSettings.hasOwnProperty('gamble') && spinSettings.gamble){
    game.models.GambleModel.setIsGamble(true)
  }

  const transition = () => spinModel.respin.length ? getRespinState() :
    freespinModel.add
      ? getFreespinAddState(false)
      : AutoSpinManager.isAllowed()
        ? getAutoState()
        : getTransitionState()

  return {
    name,
    actions,
    transition,
  }
}
